export class ReSendDocumentDTO {
    deviceName?: string
}
